export enum TaskTypeEnum {
  Sales = 1,
  Production = 2,
}
